import {Component, OnInit} from '@angular/core';
import {PropertyModel, PropertyUsages} from '../../../properties/models/property.model';
import {ApiResponse, BaseModalComponent} from 'common-shared';
import {PropertyService} from '../../../properties/property.service';
import {BehaviorSubject} from "rxjs";
import {plainToInstance} from "class-transformer";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'mes-web-property-edit-modal',
  templateUrl: './property-edit-modal.component.html'
})
export class PropertyEditModalComponent extends BaseModalComponent implements OnInit {
  propertyId: string;
  propertyName: string;
  property: PropertyModel = new PropertyModel();
  response: ApiResponse<any>;
  isPristine$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(private propertyService: PropertyService) {
    super();
  }

  ngOnInit() {
    if (this.propertyId) {
      this.propertyService.loadOne(this.propertyId).subscribe(value => this.property = value);
    } else {
      this.property = PropertyModel.CreateDefault({Code: this.propertyName, Name: this.propertyName});
    }
  }

  onChanged(isPristine: boolean) {
    this.isPristine$.next(isPristine);
  }

  save(withClose: boolean = true) {
    this.propertyService.save(this.property).subscribe(value => this.onSaveSuccess(value, withClose), value => this.onSaveFail(value, withClose));
  }

  private onSaveSuccess(savedValue: PropertyModel, withClose: boolean): void {
    this.propertyId = savedValue.Id;
    if (withClose) {
      this.close();
    }
  };

  private onSaveFail(response: HttpErrorResponse, withClose: boolean): void {
    const propertyUsages = plainToInstance(PropertyUsages, response.error.data?.Usages);
    if (response.status == 409 && !!propertyUsages) {
      this.propertyService.showPropertyUsages(propertyUsages, this.property).onHide$.subscribe(dialogClosed => {
        if (dialogClosed.data === true) {
          this.property.ForceSave = true;
          this.propertyService.save(this.property).pipe(takeUntil(this.componentDestroyed)).subscribe(value => this.onSaveSuccess(value, withClose), value => this.onSaveFail(value, withClose));
        }
      });
    } else {
      this.onOtherSaveFail(response);
    }
  };

  private onOtherSaveFail(response: any): void {
    this.response = response.error;
  }

  delete() {
    this.propertyService.remove(this.property).subscribe(value => {
      this.propertyId = null;
      this.close();
    }, value1 => {
      this.response = value1.error;
    });
  }

  add() {
    this.propertyService.addNew(this.property).subscribe(value => {
      this.propertyId = value.Id;
      this.close();
    }, value1 => {
      this.response = value1.error;
    });
  }
}
